module.exports = __webpack_public_path__ + "static/media/bianca_villamor.5ac4068a.png";